import React from "react";
var __jsx = React.createElement;
import { useMemo, useState } from "react";
import SubFilterOpenButton from "../SubFilterOpenButton/SubFilterOpenButton";
import stl from "./AsideBody.module.css";
import { CDN_LINK } from "@globalConfig";
import OpenMenuSelection from "../OpenMenuSelection/OpenMenuSelection";
import { isRangeFilter } from "@/pages/search/searchHooks/utils";
import RemoveFiltersNote from "../RemoveFiltersNote/RemoveFiltersNote";
import { useTranslation } from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import { trackEvents } from "@/common/events/events";
function AsideBody(_ref) {
  var filters = _ref.filters,
    handleOpenFilter = _ref.handleOpenFilter,
    selectedOptions = _ref.selectedOptions,
    handleFilterChange = _ref.handleFilterChange,
    tempSelectedOptions = _ref.tempSelectedOptions,
    dealFacet = _ref.dealFacet,
    handleDeleteFilters = _ref.handleDeleteFilters,
    setFilterOnMobile = _ref.setFilterOnMobile;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    showAllFiltersMobile = _useState[0],
    setShowAllFiltersMobile = _useState[1];
  var isMobile = useIsMobile();
  var isMakeSelected = useMemo(function () {
    return selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function (option) {
      return (option === null || option === void 0 ? void 0 : option.filterField) === "make_id";
    });
  }, [selectedOptions]);
  var isModelSelected = useMemo(function () {
    return selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function (option) {
      return (option === null || option === void 0 ? void 0 : option.filterField) === "model_id";
    });
  }, [selectedOptions]);
  var getFiltersCount = function getFiltersCount(filterName) {
    var _selectedOptions$filt;
    var isRange = isRangeFilter(filterName);
    if (isRange) {
      var selectedOption = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (option) {
        return (option === null || option === void 0 ? void 0 : option.filterField) === filterName;
      });
      return selectedOption ? "".concat(selectedOption.range_values.from, "-").concat(selectedOption.range_values.to) : null;
    }
    return selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$filt = selectedOptions.filter(function (option) {
      return (option === null || option === void 0 ? void 0 : option.filterField) === filterName;
    })) === null || _selectedOptions$filt === void 0 ? void 0 : _selectedOptions$filt.length;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: "filter-body-wrapper",
    className: [stl.wrapper, showAllFiltersMobile ? stl.showAllFiltersMobile : undefined].join(" ")
  }, (dealFacet === null || dealFacet === void 0 ? void 0 : dealFacet.name) && /*#__PURE__*/React.createElement("div", {
    className: stl.dealFacetWrapper
  }, /*#__PURE__*/React.createElement("button", {
    id: "filter-body-deal-btn",
    onClick: function onClick() {
      isMobile && setFilterOnMobile(false);
      handleFilterChange({
        filterField: "deal_id"
      }, {
        id: dealFacet.id,
        name: dealFacet.name
      }, true);
      trackEvents("browse_cars", {
        referral_location: "listing",
        browse_variant: "clearance_offers",
        variant_value: "null",
        category_path: null
      });
    },
    className: "interActiveBackPurple"
  }, dealFacet === null || dealFacet === void 0 ? void 0 : dealFacet.name, /*#__PURE__*/React.createElement("img", {
    width: 24,
    height: 24,
    src: CDN_LINK + "/assets/images/whtBck.svg",
    alt: "arrow"
  }))), (filters === null || filters === void 0 ? void 0 : filters.length) <= 4 ? /*#__PURE__*/React.createElement(RemoveFiltersNote, null) : filters === null || filters === void 0 ? void 0 : filters.map(function (filter, i) {
    var displayName = filter.displayName;
    var filterName = filter === null || filter === void 0 ? void 0 : filter.filterField;
    var count = getFiltersCount(filterName);
    if (filterName === "model_id" && !isMakeSelected) return;
    if (filterName === "trim_id" && !isModelSelected) return;
    if (filterName === "condition_id") {
      return /*#__PURE__*/React.createElement(OpenMenuSelection, {
        key: i,
        filter: filter,
        tempSelectedOptions: tempSelectedOptions,
        selectedOptions: selectedOptions,
        isCampaign: false,
        isOpen: true,
        options: filter.values,
        onChange: handleFilterChange,
        fieldName: filterName,
        selectedOption: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.filter(function (option) {
          return (option === null || option === void 0 ? void 0 : option.filterField) === filterName;
        }),
        title: displayName,
        setFilterOnMobile: function setFilterOnMobile() {}
      });
    }
    return /*#__PURE__*/React.createElement(SubFilterOpenButton, {
      key: i,
      filterField: filterName,
      option: selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find(function (option) {
        return (option === null || option === void 0 ? void 0 : option.filterField) === filterName;
      }),
      handleDeleteFilters: handleDeleteFilters,
      isRange: isRangeFilter(filterName),
      isLoading: false,
      count: count || null,
      disabled: false,
      name: displayName,
      onClick: function onClick() {
        handleOpenFilter(filter);
      }
    });
  }), filters.length > 4 && /*#__PURE__*/React.createElement("div", {
    id: "filter-body-mobile-more-btn",
    className: [stl.mobileMoreBtn, "m-show"].join(" "),
    onClick: function onClick() {
      setShowAllFiltersMobile(!showAllFiltersMobile);
    }
  }, /*#__PURE__*/React.createElement("span", null, !showAllFiltersMobile ? t("شاهد المزيد من خيارات البحث", {
    ns: "web_search"
  }) : t("إخفاء خيارات البحث الاخرى ", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/arrAcc.svg",
    alt: "arrow",
    width: 12,
    height: 7
  }))));
}
export default AsideBody;